<template>
  <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false,
      animationId: null
    };
  },
  methods: {
    GoTop() {
      // 防止重复点击导致多个动画叠加
      if (this.animationId) {
        window.cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      const scrollStep = () => {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        // 接近顶部时直接归零，确保动画能停止
        if (currentScroll <= 1) {
          window.scrollTo(0, 0);
          this.animationId = null;
          return;
        }
        window.scrollTo(0, currentScroll - currentScroll / 10);
        this.animationId = window.requestAnimationFrame(scrollStep);
      };
      this.animationId = window.requestAnimationFrame(scrollStep);
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue